<template>
    <div class="resolve_project">
        <div class="project_item" v-for="(item, index) in projects" :key="index">
            <div v-if="(index+1)%2!==0" class="item_container">
                <div class="item">
                    <div class="image image_left">
                        <img :src="item.image">
                    </div>
                    <div class="context context_right">
                        <div class="title">{{ item.title }}</div>
                        <div class="content">{{ item.content }}</div>
                        <div class="item_button" >
                            <!-- <img v-if="isHover[index]" :src="btnUrl1" @mouseenter="changeBtnTrue(index)" @mouseleave="changeBtnFalse(index)">
                            <img v-else :src="btnUrl2" @mouseenter="changeBtnTrue(index)" @mouseleave="changeBtnFalse(index)"> -->
                            <img :src="isHover[index] ? btnUrl1 : btnUrl2" @mouseenter="changeBtnTrue(index)" @mouseleave="changeBtnFalse(index)">
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="item_container">
                <div class="item">
                    <div class="image image_right">
                        <img :src="item.image">
                    </div>
                    <div class="context context_left">
                        <div class="title">{{ item.title }}</div>
                        <div class="content">{{ item.content }}</div>
                        <div class="item_button" >
                            <!-- <img v-if="isHover[index]" :src="btnUrl1" @mouseenter="changeBtnTrue(index)" @mouseleave="changeBtnFalse(index)">
                            <img v-else :src="btnUrl2" @mouseenter="changeBtnTrue(index)" @mouseleave="changeBtnFalse(index)"> -->
                            <img :src="isHover[index] ? btnUrl1 : btnUrl2" @mouseenter="changeBtnTrue(index)" @mouseleave="changeBtnFalse(index)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            // projects: [],
            isHover: [],
            btnUrl1: require("../../assets/image/button2.png"),
            btnUrl2: require("../../assets/image/button1.png")
        }
    },
    props: {
        projects:Array
    },
    methods: {
        changeBtnTrue(index){
            // this.isHover[index] = false;
            this.$set(this.isHover, index, false);
            // console.log(this.isHover[index]);
        },
        changeBtnFalse(index){
            // this.isHover[index] = true;
            this.$set(this.isHover, index, true);
            // console.log(this.isHover[index]);
        },
    },
    computed: {
        // projectsLength() {
        //     return this.projects.length;
        // }
    },
    watch: {
        projects(newVal) {
            console.log('Projects updated:', newVal);
            if (Array.isArray(newVal)) {
                newVal.forEach(() => {
                    this.isHover.push(true);
                });
            }
        }
    },
    mounted() {
        // console.log(this.projects);
        // this.projects.forEach((item, index) => {
        //     this.isHover.push(true);
        // })
    }
}
</script>

<style scoped lang="less">
.resolve_project {
    background-color: rgb(0, 0, 0);
    // height: 30rem;
    // width: 80%;
    // margin: 0 auto;
    .project_item{
        height: 40rem;
        // width: 100%;
        // border: 1px solid #d0cfcf; 
        // margin-bottom: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .item_container{
            width: 100%;
            height: 100%;
            color: #c1c1c1;
            display: flex;
            justify-content: center;
            align-items: center;
            .item{
                width: 1000px;
                height: 100%;
                // background-color: rgb(134, 172, 255);
                margin: 0 auto;
                position: relative;
                .image{
                    width: 80%;
                    height: 76%;
                    position: absolute;
                    // background-color: rgb(206, 187, 238);
                    // background-image: url('../../assets/image/底.png');
                    background-size: cover;
                    border-radius: 0.7rem;
                    top: 50%;
                    transform: translateY(-50%);
                    img{
                        width: 100%;
                    }
                }
                .image_left{
                    left: 0;
                }
                .image_right{
                    right: 0;
                }
                .context{
                    width: 50%;
                    top: 50%;
                    transform: translateY(-50%);
                    border-radius: 1rem;
                    background-color: rgb(55, 55, 55);
                    position: absolute;
                    .title{
                        font-size: 1.3rem;
                        color: #fff;
                        padding: 2rem 3.5rem;
                    }
                    .content{
                        padding: 0rem 3.5rem 1rem;
                        font-size: 0.7rem;
                        letter-spacing: 1px;
                        line-height: 1.8;
                    }
                    .item_button{
                        height: 4rem;
                        width: 4rem;
                        left: 3.5rem;
                        // background-color: aquamarine;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }
                }
                .context_right{
                    right: -5rem;
                }
                .context_left{
                    left: -5rem;
                }
            }
        }
    }
}
</style>
